import client from 'lib/api/client';
import {VOD_AFREECATV_DOMAIN} from 'constants/config';

/**
 * 편집각 API
 */

interface IEditangleList {
  bbs_no: number;
  bj_id: string;
  edit_time: number;
  file_info_key: string;
  highlight_status: number;
  idx: number;
  station_no: number;
  title_no: number;
  user_id: string;
  user_nick: string;
}

export interface IGetEditangleInfo {
  titleNo: number;
  RESULT?: number;
  MSG?: string;
  EDITANGLE_CNT?: number;
  EDITANGLE_LIST?: IEditangleList[];
}

export async function getEditangleInfo(data: IGetEditangleInfo) {
  const {titleNo} = data;
  // const isDev = process.env.NODE_ENV === "development" ? true : false;
  const path = '/api/editangle_api.php';

  const form = new FormData();
  form.append('szWork', 'EDITANGLE_SEL');
  form.append('title_no', JSON.stringify(titleNo));
  const response = await client.post<IGetEditangleInfo>(path, form, {
    baseURL: VOD_AFREECATV_DOMAIN,
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
  return response.data;
}
